export default () => ({
  currentStep: 1,
  totalSteps: 7,
  submitting: false,
  focusedField: null,
  errors: {},
  submitted: false,
  formData: {
    name: '',
    contact_name: '',
    contact_function: '',
    email: '',
    phone: '',
    website: '',
    signatory_name: '',
    publication_authorized: false,
    recontact_accepted: false,
    axe1_regulatory_scopes: [],
    axe1_broker_profiles: [],
    axe1_network_specializations: [],
    axe1_geographic_scope: '',
    axe2_services: {
      compliance_regulatory_support: '',
      legal_regulatory_watch: '',
      training_certification: '',
      business_tools_crm: '',
      product_company_sourcing: '',
      legal_contractual_support: '',
      commercial_marketing_support: '',
      transfer_succession_support: '',
      purchasing_pooling: '',
    },
    axe2_partner_companies_count: '',
    axe2_other_services: '',
    axe3_entry_fee: '',
    axe3_annual_fee: '',
    axe3_commission_rate: '',
    axe3_tools_service_fees: '',
    axe3_remuneration_model: '',
    axe3_remuneration_other_details: '',
    axe3_contractual_commitment: '',
    axe3_joining_prerequisites: [],
    axe3_prerequisite_contribution_details: '',
    axe3_exit_clause: '',
    axe3_exit_conditions_details: '',
    axe4_creation_year: '',
    axe4_member_count: '',
    axe4_intermediated_volume: '',
    axe4_member_retention_rate: '',
    axe4_legal_form: '',
    axe4_certifications: [],
    axe4_certifications_details: '',
    axe4_references_available: '',
    axe5_capital_independence: '',
    axe5_portfolio_ownership: '',
    axe5_placement_freedom: '',
    axe5_minimum_production_required: '',
    axe5_commercial_neutrality_details: '',
  },

  stepForErrorKey(key) {
    if (['name', 'contact_name', 'contact_function', 'email', 'phone', 'website'].includes(key)) return 1;
    if (key.startsWith('axes_data.axe1')) return 2;
    if (key.startsWith('axes_data.axe2')) return 3;
    if (key.startsWith('axes_data.axe3')) return 4;
    if (key.startsWith('axes_data.axe4')) return 5;
    if (key.startsWith('axes_data.axe5')) return 6;
    return 7;
  },

  async submitForm(formEl) {
    this.submitting = true;
    this.errors = {};

    try {
      await window.axios.post(formEl.action, this.formData);
      this.submitted = true;
    } catch (error) {
      if (error.response?.status === 422) {
        this.errors = error.response.data?.errors ?? {};
        const steps = Object.keys(this.errors).map(k => this.stepForErrorKey(k));
        if (steps.length) {
          this.currentStep = Math.min(...steps);
        }
      }
    } finally {
      this.submitting = false;
    }
  },

  /*buildAxesData() {
    return JSON.stringify({
      axe1: {
        regulatory_scopes: this.formData.axe1_regulatory_scopes,
        broker_profiles: this.formData.axe1_broker_profiles,
        network_specializations: this.formData.axe1_network_specializations,
        geographic_scope: this.formData.axe1_geographic_scope,
      },
      axe2: {
        services: this.formData.axe2_services,
        partner_companies_count: this.formData.axe2_partner_companies_count,
        other_services: this.formData.axe2_other_services,
      },
      axe3: {
        entry_fee: this.formData.axe3_entry_fee,
        annual_fee: this.formData.axe3_annual_fee,
        commission_rate: this.formData.axe3_commission_rate,
        tools_service_fees: this.formData.axe3_tools_service_fees,
        remuneration_model: this.formData.axe3_remuneration_model,
        remuneration_other_details: this.formData.axe3_remuneration_other_details,
        contractual_commitment: this.formData.axe3_contractual_commitment,
        joining_prerequisites: this.formData.axe3_joining_prerequisites,
        prerequisite_contribution_details: this.formData.axe3_prerequisite_contribution_details,
        exit_clause: this.formData.axe3_exit_clause,
        exit_conditions_details: this.formData.axe3_exit_conditions_details,
      },
      axe4: {
        creation_year: this.formData.axe4_creation_year,
        member_count: this.formData.axe4_member_count,
        intermediated_volume: this.formData.axe4_intermediated_volume,
        member_retention_rate: this.formData.axe4_member_retention_rate,
        legal_form: this.formData.axe4_legal_form,
        certifications: this.formData.axe4_certifications,
        certifications_details: this.formData.axe4_certifications_details,
        references_available: this.formData.axe4_references_available,
      },
      axe5: {
        capital_independence: this.formData.axe5_capital_independence,
        portfolio_ownership: this.formData.axe5_portfolio_ownership,
        placement_freedom: this.formData.axe5_placement_freedom,
        minimum_production_required: this.formData.axe5_minimum_production_required,
        commercial_neutrality_details: this.formData.axe5_commercial_neutrality_details,
      },
    });
  },*/
});
